import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Add } from "@material-ui/icons";
import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export default class AddSchemaDetail extends Component {
  constructor(props) {
    super();
    this.state = {
      showAddModal: false,
      hasError: false,
      disableAdd: false,
      bschema_id: props.schema_id,
      updated_by: cookies.get("email"),
      created_by: cookies.get("email"),
    };
    this.handleshowAddModal = this.handleshowAddModal.bind(this);
  }

  handleshowAddModal = (e) => {
    this.setState({ showAddModal: !this.state.showAddModal, hasError: false });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disableAdd: true });
    axios
      .post("api/basic_schema_detail", this.state)
      .then((res) => {
        this.props.parentCallback(true);
        this.setState({ showAddModal: false, disableAdd: false, });
      })
      .catch((err) => {
        this.setState({ disableAdd: false, hasError: true, });
      });
  };

  render() {
    return (
      <>
        <button
          className="btn btn-outline-primary btn-sm float-right"
          title="Add New Schema Item"
          onClick={this.handleshowAddModal}
        >
          <Add /> New Schema Item
        </button>
        <Modal
          size="md"
          show={this.state.showAddModal}
          onHide={() =>
            this.setState({ showAddModal: !this.state.showAddModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Add New Schema Item</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div
                  className={
                    this.state.hasError
                      ? "alert alert-danger"
                      : "alert alert-danger d-none"
                  }
                  role="alert"
                >
                  Earning/Deduction Type Already Exist in Schema
                </div>
              </div>
            </div>
            <form onSubmit={this.handleSubmit} id="contact-form">
              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  <label>Transaction Type</label>
                  <select
                    class="form-control custom-select"
                    required
                    onChange={(e) => this.setState({ ed_id: e.target.value })}
                  >
                    <option value="">Select Schema</option>
                    {this.props.earningDeductDD.map((ed) => (
                      <option key={ed.id} value={ed.id}>
                        {ed.type} - {ed.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-12 col-sm-12">
                  <label>Pay Period Release</label>
                  <select
                    className="form-control custom-select"
                    required
                    onChange={(e) => {
                      this.setState({ pay_period: e.target.value });
                    }}
                    value={this.state.pay_period}
                  >
                    <option value="">Select Pay Period Release</option>
                    <option value="2">15th (Semi-Monthly)</option>
                    <option value="4">30th (Semi-Monthly)</option>
                    <option value="1">15th & 30th (Semi-Monthly)</option>
                    <option value="3">30th (Monthly)</option>
                  </select>
                </div>
              </div>

              <div className="float-right">
                <button
                  type="submit"
                  disabled={this.state.disableAdd}
                  className="btn btn-primary btn-sm mr-2"
                >
                  Save
                </button>
                <button
                  onClick={this.handleshowAddModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
